/**
 * Wait until `DOMContentLoaded` to do something.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/Events/DOMContentLoaded}
 * @param callback A function that is called when the `DOMContentLoaded`
 * event has been fired and `document.readyState` is `'complete'`.
 */
export default function domContentLoaded(callback) {
  if (document.attachEvent) {
    // IE <= 8, using attachEvent to detect browser instead of
    // addEventListener in order to avoid errors caused by polyfills.
    // Execute callback only with 'complete' since 'interactive' can
    // cause some malfunctions.
    if (document.readyState === 'complete') {
      callback();
    } else {
      document.attachEvent('onreadystatechange', function () {
        if (document.readyState === 'complete') {
          callback();
        }
      });
    }
  } else if (document.readyState !== 'loading') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback);
  }
}
//# sourceMappingURL=domContentLoaded.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/domContentLoaded.js
// module id = 504
// module chunks = 0 1